// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__U2GH9","container":"Page_container__ZEgzI"};